import {
  COMPLETE_KYC,
  COMPLETE_KYC_SUCCESS,
  COMPLETE_KYC_FAILURE,
} from "../actionTypes";

export const completeKYC = (payload) => ({
  type: COMPLETE_KYC,
  payload,
});

export const completeKYCSuccess = (payload) => ({
  type: COMPLETE_KYC_SUCCESS,
  payload,
});

export const completeKYCFailure = () => ({
  type: COMPLETE_KYC_FAILURE,
});
